import Layout from "../../components/Layout/Layout";

function Customers(props) {
  return (
    <Layout {...props}>
      <h4>Customers</h4>
    </Layout>
  );
}

export default Customers;
